export enum ListVariant {
    Default = "default",
    Square = "sqare"
}
